import { Button } from '@casumo/dojo-react';
import { memo } from 'react';
import useRegister from '../../api/hooks/useRegister.tsx';
import { isRegistrationInFlight, useRegistrationStore } from '../../store/store.ts';
import { TEST_ID } from '../../utils/constants';
import { GtmEvents } from '../../utils/gtm/gtm.ts';

type TRegisterSecondaryButton = {
  handleNext: ({ gtmPayload, redirectTo }: {
    gtmPayload?: Record<string, string>;
    redirectTo?: string;
    canProceed?: boolean;
  }) => void;
  label?: string;
  gtmPayload?: Record<string, string>;
}

const RegisterSecondaryButton = ({ label }: TRegisterSecondaryButton) => {
  const { setFormData } = useRegistrationStore();
  const { formData, setMetadata } = useRegistrationStore.getState();
  const { registerUser, isRegistering } = useRegister();

  if (!formData || !setMetadata) return;

  const handleClick = async () => {
    if (isRegistrationInFlight()) return;

    GtmEvents.logMarketingConsent(false);
    const marketingDetails = {
      marketingConsent: {
        casino: {
          contactBySms:              false,
          contactByEmail:            false,
          contactByPhone:            false,
          contactByPost:             false,
          contactByPushNotification: false,
        },
        sports: {
          contactBySms:              false,
          contactByEmail:            false,
          contactByPhone:            false,
          contactByPost:             false,
          contactByPushNotification: false,
        },
      },
      subscribeToMarketingMaterial: false,
    };
    setFormData(marketingDetails);
    await registerUser({ ...formData, ...marketingDetails });
  };

  return (
    <Button variant="tertiary"
      onClick={handleClick}
      disabled={isRegistering}
      data-testid={TEST_ID.BUTTON_SECONDARY}
    >
      {label}
    </Button>
  )
};

const Memoized = memo(RegisterSecondaryButton);
Memoized.displayName = 'RegisterSecondaryButton';

export default Memoized;
